import React from "react";

const Header = () => {
  return (
    <div>
      <h2 className="flamesHeader2">FLAMES GAME</h2>
    </div>
  );
};

export default Header;
